// @ngInject
function OrderRowCommentDialogService($uibModal) {

    return {
        showDialog: showDialog
    };

    function showDialog(orderArticle) {

        var modalDefaults = {
            backdrop: 'static',
            keyboard: true,
            controller: 'OrderRowCommentDialogController as vm',
            templateUrl: 'main/order/orderDialogs/orderRowCommentDialog/orderRowCommentDialog.tpl.html',
            size: 'xs'
        };

        modalDefaults.resolve = {
            orderArticle: function () {
                return orderArticle;
            }
        };

        return $uibModal.open(modalDefaults).result;
    }
}

// @ngInject
function OrderRowCommentDialogController($uibModalInstance, orderArticle) {
    var vm = this;

    vm.orderArticle = orderArticle;
    vm.closeModal = closeModal;
    vm.comment = orderArticle.orderRows[0].comment;

    function closeModal(keepChanges) {
        if(keepChanges){
            _.forEach(orderArticle.orderRows, function(row){
                row.comment = vm.comment;
            });

            $uibModalInstance.close(orderArticle.orderRows);
        }
        else
            $uibModalInstance.close(false);
    }
}

angular
    .module('order.orderRowCommentDialog', [])
    .service('OrderRowCommentDialogService', OrderRowCommentDialogService)
    .controller('OrderRowCommentDialogController', OrderRowCommentDialogController);
